const APP_ON_CONTEXT_READY = 'APP_ON_CONTEXT_READY';

export default {
    APP_ON_CONTEXT_READY,
};
